// extracted by mini-css-extract-plugin
module.exports = {"link":"_1A00c","root":"_1OEee","label":"_3i4L1"};